module.exports = __webpack_public_path__ + "static/media/neon-buildings.d37282cc.png";